<footer>
    &copy;
    {{ date | date: 'yyyy' }} Sequens IT
</footer>
